import template from './template.html'

angular.module('contabilidad.polizas')
  .config(['$stateProvider', Config])

function Config ($stateProvider) {
  $stateProvider.state('contabilidad.polizas.pagosNominaUSD', {
    url: '/pagosNominaUSD?{fecha_inicio:date}&{fecha_fin:date}&:idOperadora&:ids_empresas&:ids_nominas&:tipo_poliza',
    template,
    data: {
      title: 'Pagos de Nómina USD',
    },
    params: {
      ids_empresas: {array: true},
      ids_nominas: {array: true},
    },
    resolve: {
      nominas: ['ContabilidadPolizas', '$stateParams', function (ContabilidadPolizas, $stateParams) {
        var fecha_inicio = $stateParams.fecha_inicio,
          fecha_fin = $stateParams.fecha_fin,
          id_operadora = $stateParams.idOperadora,
          ids_empresas = $stateParams.ids_empresas,
          nominasSeleccionadas = $stateParams.ids_nominas || []

        return fecha_inicio && fecha_fin && ids_empresas ? ContabilidadPolizas.traerNominas(
          fecha_inicio,
          fecha_fin,
          id_operadora,
          ids_empresas, 2,
        ).then(function (nominas) {
          return nominas.map(function (item) {
            item.seleccionado = nominasSeleccionadas.indexOf(item.ID_Nomina) >= 0
            return item
          })
        }) : undefined
      }],
      polizas: ['pagosNominasUSDService', '$stateParams', function (pagosNominasUSDService, $stateParams) {
        var fecha_inicio = $stateParams.fecha_inicio,
          fecha_fin = $stateParams.fecha_fin,
          ids_empresas = $stateParams.ids_empresas,
          ids_nominas = $stateParams.ids_nominas,
          tipo_poliza = $stateParams.tipo_poliza

        return fecha_inicio && fecha_fin && ids_empresas && ids_nominas && tipo_poliza ? pagosNominasUSDService.obtenerInformacionPagosNominaUSD(
          ids_nominas, tipo_poliza,
        ) : undefined
      }],

    },
    controllerAs: '$ctrl',
    controller: Controller,
  })
}

Controller.$inject = ['polizas', 'nominas', '$dialog', '$stateParams', '$location']

function Controller (polizas, nominas, $dialog, $stateParams, $location) {
  var $ctrl = this

  $ctrl.data = polizas
  $ctrl.nuevoData = polizas
  var Totales
  if ($ctrl.data) {
    $ctrl.nuevoData = ordenarArray($ctrl.data)
    $ctrl.nuevoData.forEach(function (item) {
      Totales = CalcularTotales(item)
      item.TotalCargo = Totales.TotalCargo
      item.TotalAbono = Totales.TotalAbono
    })
  }
  $ctrl.nominas = nominas
  $ctrl.traerNominas = traerNominas
  $ctrl.obtenerInformacionPagosNominaUSD = obtenerInformacionPagosNominaUSD
  $ctrl.exportar = exportar
  $ctrl.actualizarEmpresas = actualizarEmpresas
  $ctrl.TotalAbonos = 0
  $ctrl.TotalCargos = 0

  $ctrl.opciones = {
    fecha_inicio: $stateParams.fecha_inicio || new Date(),
    fecha_fin: $stateParams.fecha_fin || new Date(),
    ids_empresas: $stateParams.ids_empresas || [],
    ids_nominas: $stateParams.ids_nominas || [],
    id_operadora: $stateParams.idOperadora || null,
    tipo_poliza: $stateParams.tipo_poliza || undefined,
  }

  function traerNominas () {
    $location.search({
      fecha_inicio: $ctrl.opciones.fecha_inicio.toYMD(),
      fecha_fin: $ctrl.opciones.fecha_fin.toYMD(),
      idOperadora: $ctrl.opciones.id_operadora,
      ids_empresas: $ctrl.opciones.ids_empresas,
    })
  }

  function obtenerInformacionPagosNominaUSD () {
    $location.search({
      fecha_inicio: $ctrl.opciones.fecha_inicio.toYMD(),
      fecha_fin: $ctrl.opciones.fecha_fin.toYMD(),
      ids_empresas: $ctrl.opciones.ids_empresas,
      ids_nominas: $ctrl.opciones.ids_nominas,
      idOperadora: $ctrl.opciones.id_operadora,
      tipo_poliza: $ctrl.opciones.tipo_poliza,
    })
  }

  function actualizarEmpresas (data) {
    $ctrl.opciones.ids_empresas = data.ids_empresas
    $ctrl.opciones.id_operadora = data.idOperadora
    // $ctrl.nominas = undefined;
  }

  function exportar () {
    $dialog.show('contabilidad.polizas.exportar', {
      data: $ctrl.nuevoData,
      fecha_inicio: $ctrl.opciones.fecha_inicio,
      // Se agregó ésta propiedad para indicar qué es lo que se va a exportar
      config: {
        fecha_inicio: $ctrl.opciones.fecha_inicio,
        fecha_fin: $ctrl.opciones.fecha_fin,
        nominas: $ctrl.nominas.filter(function (item) {
          return item.seleccionado
        }),
        archivo: 'Pagos Nomina USD ',
        tipo_poliza: 'pagosNominaUSD',
      },
    })
  }

  function ordenarArray (data) {
    var nuevoData = [],
      aux = [],
      total = 0,
      Diferencia = 0,
      referencias = [],
      ID_Nomina,
      Cta_MXN,
      Fecha,
      Cta_UtildadPerdidaCambiaria,
      Tipo_Movimiento,
      Importe_Provision = 0,
      Cuenta_Contable_Deudor,
      Tipo_Moneda,
      Moneda,
      Forma_Pago,
      Cuenta_Contable_Complementaria,
      Total_Dolares = 0,
      Importe_Pago,
      Cuenta_Contable

    if (data.length > 0) {
      data.map(function (item) {
        if (referencias.indexOf(item.Referencia) === -1) {
          referencias.push(item.Referencia)
        }
      })

      referencias.map(function (item) {
        data.map(function (ele) {
          if (item === ele.Referencia) {
            aux.push(ele)
            total += ele.Importe_Pago
            ID_Nomina = ele.ID_Nomina
            Fecha = ele.Fecha
            Importe_Provision += ele.Importe_Provision
            Cta_MXN = ele.Cta_MXN
            Forma_Pago = ele.Forma_Pago
            Cta_UtildadPerdidaCambiaria = ele.Cta_UtildadPerdidaCambiaria
            Diferencia += ele.Diferencia
            Tipo_Movimiento = ele.Tipo_Movimiento
            Cuenta_Contable_Deudor = ele.Cuenta_Contable_Deudor
            Tipo_Moneda = ele.Tipo_Moneda
            Moneda = ele.Moneda
            Cuenta_Contable_Complementaria = ele.Cuenta_Contable_Complementaria
            Total_Dolares += ele.Importe
            Importe_Pago = ele.Importe_Pago
            Cuenta_Contable = ele.Cuenta_Contable
          }
        })
        nuevoData.push({
          Referencia: item,
          Total_Pesos: total,
          ID_Nomina: ID_Nomina,
          Cta_MXN: Cta_MXN,
          Fecha: Fecha,
          Importe_Provision: Importe_Provision,
          Cta_UtildadPerdidaCambiaria: Cta_UtildadPerdidaCambiaria,
          Diferencia: Diferencia,
          Tipo_Movimiento: Tipo_Movimiento,
          Tipo_Moneda: Tipo_Moneda,
          Moneda: Moneda,
          Cuenta_Contable_Complementaria: Cuenta_Contable_Complementaria,
          Cuenta_Contable_Deudor: Cuenta_Contable_Deudor,
          TotalCargo: 0, // Tipo_Movimiento === 'C' ? (total + Diferencia) : total ,
          TotalAbono: 0, // Tipo_Movimiento === 'A' ? (Importe_Provision + Diferencia) : Importe_Provision,
          Total_Dolares: Total_Dolares,
          Importe_Pago: Importe_Pago,
          Forma_Pago: Forma_Pago,
          Cuenta_Contable: Cuenta_Contable,
          hijos: aux,
        })

        aux = []
        total = 0
        Importe_Provision = 0
        Total_Dolares = 0
        Diferencia = 0
      })
    }
    return nuevoData
  }

  function CalcularTotales (item) {
    var TotalAbono = 0
    var TotalCargo = 0

    TotalCargo += item.Total_Pesos

    if (item.Diferencia > 0 && item.Tipo_Moneda === '2' && item.Moneda === '1') {
      if (item.Tipo_Movimiento === 'C') {
        TotalCargo += item.Diferencia
      }
      if (item.Tipo_Movimiento === 'A') {
        TotalAbono += item.Diferencia
      }
    }

    if (item.Tipo_Moneda === '2' && item.Moneda === '1') {
      TotalAbono += item.Importe_Provision
    }

    if (item.Tipo_Moneda === '2' && item.Moneda === '2' && item.Cuenta_Contable_Deudor !== '') {
      TotalAbono += item.Importe_Pago
    }

    if (item.Tipo_Moneda === '2' && item.Moneda === '2' && item.Cuenta_Contable_Deudor === '') {
      TotalAbono += item.Total_Dolares
    }

    if (item.Tipo_Moneda === '2' && item.Moneda === '2' && item.Cuenta_Contable_Deudor === '') {
      TotalAbono += item.Importe_Pago - item.Total_Dolares
    }
    return {
      TotalAbono: TotalAbono,
      TotalCargo: TotalCargo,
    }
  }

}




// WEBPACK FOOTER //
// ./src/contabilidad/polizas/components/pagosnominasusd/component.js